/**
 * @author fputra on 01/04/22
 */

import request from '../_network/request'

const getCashback = (params) => {
    return request({
        url: `/groovy/cashback/CashbackSvc?op=10`,
        method: 'POST',
        data: params
    })
}

const transCashback = (params) => {
    console.log(params)
    return request({
        url: `/groovy/cashback/CashbackSvc?op=11`,
        method: 'POST',
        data: params
    })
}

const getTransactionCashback = (params) => {
    return request({
        url: `/groovy/cashback/CashbackSvc?op=13&id=` + params,
        method: 'GET',
    })
}

export const cashbackServices = {
    getCashback,
    transCashback,
    getTransactionCashback
}
